/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { baseComponentManager } from '../../registry/Components';
import { ComponentManagerFn } from '../../registry/Component.type';
import { defaultValue } from './EmbedPage';

const EmbedPageManager: ComponentManagerFn<'EmbedPage'> = (
  platform: Platform,
) => {
  return {
    ...baseComponentManager<'EmbedPage'>(platform, 'EmbedPage'),
    type: 'EmbedPage',
    name: 'Embed Page',
    isChildAllowed: () => false,
    defaultValue,
    props: {
      embeddedPageId: {
        label: 'Embedded Page ID',
        type: 'expression',
        helpText: 'select a page',
        returnType: async () => 'page',
      },
    },
    category: 'Containers',
    canHaveChildren: () => false,
    getDisplayText: (item) => item.props.embeddedPageId.value,
    icon: { iconName: 'layer-group' },
    description: `Embed Page component is used to render a page in another page's body. It can be used to split a heavy page into multiple sub pages.

> *Only one Developer can work on a page at a given time.*

If a page is huge with multiple tabs, you may want different Developers to work on different tabs at the same time in parallel. This can be achived by using Embed Page in each of those tabs. That way the main page will mearly act as a template or container housing multiple different pages thru' Embed Pages.
`,
  };
};

export default EmbedPageManager;
